interface NoResultProps {
  handleMouseOverSuggestions: (e: React.MouseEvent<HTMLElement>) => void;
  handleMouseLeaveSuggestions: (e: React.MouseEvent<HTMLElement>) => void;
  stopPropagation: (e: React.MouseEvent<HTMLElement>) => void;
  searchTerm: string;
}

export const NoResult = ({
  handleMouseOverSuggestions,
  handleMouseLeaveSuggestions,
  stopPropagation,
  searchTerm,
}: NoResultProps) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        padding: '10px 15px',
        marginTop: '5px',
        fontSize: '14px',
      }}
      onMouseOver={handleMouseOverSuggestions}
      onMouseLeave={handleMouseLeaveSuggestions}
      onDrag={stopPropagation}
      onDragCapture={stopPropagation}
      onDoubleClick={stopPropagation}
      onDoubleClickCapture={stopPropagation}
      onMouseMove={stopPropagation}
      onClick={stopPropagation}
    >
      <p style={{ fontWeight: 'bold', margin: '0 0 5px 0' }}>No results</p>
      <p style={{ margin: 0 }}>
        There were no results found for "{searchTerm}".
      </p>
    </div>
  );
};
